<script>
import { Helper, debounce } from '@/mixin/helper'
import FormTemperature from './Device/FormTemperature'
import FormCutEngine from './Device/FormCutEngine'
import FormSetBuzzer from './Device/FormSetBuzzer'
import FormDefaultImageCapture from './Device/FormDefaultImageCapture'
import FormFuel from './Device/FormFuel'
import FormStatusCommand from './Device/FormStatusCommand'
import FormCustomOnlineCommand from './Device/FormCustomOnlineCommand'
import FormCustomProfileCommand from './Device/FormCustomProfileCommand'
import FormAlertDeviceStatus from './Device/FormAlertDeviceStatus'
import FormSetInterval from './Device/FormSetInterval'
import FormSetRecording from './Device/FormSetRecording'
import FormSetStandBy from './Device/FormSetStandBy'
import FormSetPowermode from './Device/FormSetPowermode'
import FormSetMode from './Device/FormSetMode'
import FormSetCamera from './Device/FormSetCamera'
import FormSetHotspot from './Device/FormSetHotspot'
import FormSetVirtualSpeed from './Device/FormSetVirtualSpeed'
import FormSetDmsVss from './Device/FormSetDmsVss'
import FormSetAdasVss from './Device/FormSetAdasVss'
import FormCheckSensor from './Device/FormCheckSensor'
import FormAlarmKit from './Device/FormAlarmKit'
import FormDriverBehavior from './Device/FormDriverBehavior'
import Confirmation from '@/components/widgets/modals/Confirmation'
import { mapGetters } from 'vuex'
import { getToolsClient } from '@/services/tools'
import moment from 'moment'
import VideoList from './Video/VideoList'
import * as deviceModes from './lib/constants.js'
import FormSetTimeZone from './Device/FormSetTimeZone'
import FormAlertOperationalTime from './Device/FormAlertOperationalTime'
import { getSmsClient } from '@/services/sms'
import FormDoor from './Device/FormDoor'
import * as sensorApi from '@/services/rest-api-sms/lib/sensor/sensor'
import * as deviceApi from '@/services/rest-api-sms/lib/device/device'
import * as vehicleApi from '@/services/rest-api-sms/lib/vehicle/vehicle'
import * as sensorAlertApi from '@/services/rest-api-sms/lib/sensor-alert/sensor-alert'
import * as rawAlertApi from '@/services/rest-api-sms/lib/raw-alert/raw-alert'
import ModalLastCheckData from './Device/ModalLastCheckData'

const toolsAxios = getToolsClient()
const smsAxios = getSmsClient()

moment.locale('id')

export default {
  props: {
    region: {
      type: String,
      default: 'SG',
    },
  },
  components: {
    FormCutEngine,
    FormFuel,
    FormTemperature,
    Confirmation,
    FormStatusCommand,
    FormCustomOnlineCommand,
    FormCustomProfileCommand,
    FormAlertDeviceStatus,
    FormSetInterval,
    FormSetRecording,
    FormSetStandBy,
    VideoList,
    FormSetPowermode,
    FormSetMode,
    FormSetCamera,
    FormSetTimeZone,
    FormSetBuzzer,
    FormDefaultImageCapture,
    FormDoor,
    FormAlertOperationalTime,
    FormSetHotspot,
    FormSetVirtualSpeed,
    ModalLastCheckData,
    FormSetDmsVss,
    FormSetAdasVss,
    FormAlarmKit,
    FormDriverBehavior,
    FormCheckSensor,
  },
  mixins: [Helper],
  data() {
    return {
      loading: true,
      deviceTypes: [],
      isStart: false,
      lastDataModalStatus: false,
      imei: null,
      modal: {
        cutEngine: false,
        buzzer: false,
        fuel: false,
        temperature: false,
        door: false,
        confirmation: false,
        statusCommand: false,
        customOnlineCommand: false,
        customProfileCommand: false,
        alertDeviceStatus: false,
        setTimeInterval: false,
        setTimeStandBy: false,
        setTimeRecording: false,
        dmsCheck: false,
        setPowermode: false,
        setMode: false,
        setCamera: false,
        setTimeZone: false,
        setBuzzer: false,
        setHotspot: false,
        setVirtualSpeed: false,
        defaultImageCapture: false,
        alertOperationalTime: false,
        dmsConfiguration: false,
        adasConfiguration: false,
        checkSensor: false,
        alarmKit: false,
        driverBehavior: false,
      },
      checkSensorPayload: {
        sensorCode: null,
        sensorName: null,
        command: null,
        status: 'enable',
      },
      dmsInitialValue: null,
      adasInitialValue: null,
      vssTimezoneValue: null,
      virtualSpeedValue: null,
      vehicles: [],
      device: null,
      vehicle_last_data: {
        imei: 0,
        last_packet: '',
        last_receive: '',
        last_position_status: '',
        latitude: 0.0,
        longitude: 0.0,
        acc: 0,
        speed: 0,
        baterai: 0,
        fuel_filtered: 0,
        fuel_raw: 0,
        door: {},
        suhu: {},
        rotation_count: 0,
        rotation_direction: false,
        fuel: [],
        temperature: [],
      },
      modalMessage: null,
      title: 'Cut Engine',
      options: null,
      observer: null,
      size: 10,
      search: '',
      sensorList: null,
      vehicleList: [],
      vehicle: null,
      vehicleNew: null,
      endpoint: null,
      sensor: null,
      dataCommand: {
        device_logs: [],
        data: [],
        page: 1,
        total_pages: 0,
        total_count: 0,
        start_date: null,
        end_date: null,
        limit: 10,
        size: 10,
        search: '',
        filterType: null,

        // old
        device_logs_old: [],
        data_old: [],
        page_old: 1,
        total_pages_old: 0,
        total_count_old: 0,
        limit_old: 10,
      },
      deviceName: '',
      deviceCode: '',
      devicePowermodeCode: null,
      deviceCamera: null,
      deviceCameraMax: null,
      deviceCameraIndexStart: null,
      vehicleId: '',
      childVehicleId: null,
      debounceTimer: null,
      initialDeviceData: {},
      currentValue: null,
      deviceCommands: [],
      availableDeviceCommands: [],
      vssSensorDefaultValue: null,
      sensors: [],
      childDeviceCode: null,
    }
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      getFeatureFlagData: 'identity/getFeatureFlagData',
    }),
    isSecoActive() {
      return this.getFeatureFlagData('seco').value || false
    },
    // ★ device code yang dipakai FormDefaultImageCapture
    defaultImageCaptureDeviceCode() {
      // Kalau ada child vehicle → pakai device_code child
      // Fallback ke device_code biasa kalau child device code belum ke-load
      return this.childVehicleId ? this.childDeviceCode || this.deviceCode : this.deviceCode
    },
  },

  methods: {
    isChildVehicle() {
      return (
        this.vehicleList?.find((v) => v.vehicle_id === this.vehicleId)?.parent_vehicle_id != null
      )
    },

    async sendCommand(endpoint, additionalPayload = null, overwrite = false) {
      this.isStart = true
      if (endpoint === 'engine_off') {
        if (additionalPayload.is_enable === false) {
          endpoint = 'engine_on'
        }
        additionalPayload = null
      } else if (endpoint === 'engine_off_2') {
        if (additionalPayload.is_enable === false) {
          endpoint = 'engine_on_2'
        }
        additionalPayload = null
      }

      if (endpoint.includes('masterdata/sensor')) {
        const payload = {
          alert_idle_lo: additionalPayload?.alert_idle_lo,
          alert_idle_hi: additionalPayload?.alert_idle_hi,
          alert_lo: additionalPayload?.alert_lo,
          alert_hi: additionalPayload?.alert_hi,
          range_hi: additionalPayload?.range_hi,
          range_lo: additionalPayload?.range_lo,
          alert_min_time: additionalPayload?.alert_min_time,
          fuel_capacity: additionalPayload?.fuel_capacity,
          status_float: additionalPayload?.status_float,
          require_engine: additionalPayload?.require_engine,
          status_text: additionalPayload?.status_text,
        }
        const response = await sensorApi.update(
          this.vehicleId,
          additionalPayload.sensor_code,
          additionalPayload.pin_code,
          payload,
          this.region
        )
        if (response?.status === 200) {
          this.$toast.success(response.data.message)
        }

        this.isStart = false
        this.modal.cutEngine = false
        this.modal.fuel = false
        this.modal.temperature = false
        this.modal.door = false
        this.modal.customOnlineCommand = false
        this.modal.setTimeInterval = false
        this.modal.setPowermode = false
        this.modal.setMode = false
        this.modal.setTimeZone = false
        this.modal.setTimeRecording = false
        this.modal.setTimeStandBy = false
        this.modal.setHotspot = false
        this.modal.setVirtualSpeed = false

        return
      } else if (endpoint.includes('set_buzzer') || endpoint.includes('default_setting')) {
        const imei = typeof this.imei === 'string' ? this.imei : this.imei.imei
        const payload = {
          command: endpoint,
          sensor_code: 0,
        }

        const response = await deviceApi.command(payload, imei, this.region)

        if (response.status === 200) {
          this.$toast.success(response.data.message)
        }

        this.isStart = false
        this.modal.cutEngine = false
        this.modal.fuel = false
        this.modal.temperature = false
        this.modal.door = false
        this.modal.customOnlineCommand = false
        this.modal.setTimeInterval = false
        this.modal.setPowermode = false
        this.modal.setMode = false
        this.modal.setTimeZone = false
        this.modal.setTimeRecording = false
        this.modal.setTimeStandBy = false
        this.modal.setHotspot = false
        this.modal.setVirtualSpeed = false
        return
      }

      let payload = {
        imei: typeof this.imei === 'string' ? this.imei : this.imei.imei,
        device_code: this.deviceCode,
        vehicle_id: this.vehicleId,
        online_command: endpoint,
      }
      if (additionalPayload && !overwrite) {
        payload = { ...payload, ...additionalPayload }
      }
      if (overwrite) {
        payload = additionalPayload
      }

      const url = endpoint === 'custom_command' ? `/command/custom_command` : `/command`
      const options = {
        method: overwrite ? 'PATCH' : 'POST',
        url: overwrite ? endpoint : url,
        data: payload,
        headers: {
          'X-Region': this.region,
        },
      }

      await toolsAxios(options)
        .then(() => {
          this.$toast.success('Success Send')
        })
        .catch(({ response: { data: res } }) => {
          this.$toast.error(res.error)
        })

      this.isStart = false
      this.modal.cutEngine = false
      this.modal.fuel = false
      this.modal.temperature = false
      this.modal.door = false
      this.modal.customOnlineCommand = false
      this.modal.setTimeInterval = false
      this.modal.setPowermode = false
      this.modal.setMode = false
      this.modal.setTimeZone = false
      this.modal.setTimeRecording = false
      this.modal.setTimeStandBy = false
      this.modal.setHotspot = false
      this.modal.setVirtualSpeed = false
      this.modal.alarmKit = false
    },

    lastDataModalSetting(status) {
      if (status) {
        this.getVehicleLastData()
        this.$bvModal.show('modal-last-data')
      } else {
        this.$bvModal.hide('modal-last-data')
      }
    },

    engineCutIgnition() {
      this.endpoint = 'engine_off'
      this.modal.cutEngine = true
      this.title = 'Cut Engine (Ignition) - Kunci Kontak'
      this.options = [
        { id: true, name: 'Enable' },
        { id: false, name: 'Disable' },
      ]
      this.modalMessage = 'Yakin ingin melakukan Cut Engine (Ignition) - Kunci Kontak'
    },

    engineCutMachine() {
      this.endpoint = 'engine_off_2'
      this.modal.cutEngine = true
      this.title = 'Cut Engine (Engine) - Mesin'
      this.options = [
        { id: true, name: 'Enable' },
        { id: false, name: 'Disable' },
      ]
      this.modalMessage = 'Yakin ingin melakukan Cut Engine (Engine) - Mesin'
    },

    async engineCutIgnitionSeco() {
      await this.reloadDataDeviceCommand()
      if (this.disabledMenu(73)) {
        this.$toast.error('Pastikan untuk sensor sudah aktif')
        return
      }
      this.endpoint = 'co_seco_ignition'
      this.modal.cutEngine = true
      this.title = 'Cut Engine (Ignition SECO) - Kunci Kontak'
      this.options = [
        { id: true, name: 'Enable' },
        { id: false, name: 'Disable' },
      ]
      this.modalMessage = 'Yakin ingin melakukan Cut Engine (Ignition SECO) - Kunci Kontak'
    },

    async engineCutMachineSeco() {
      await this.reloadDataDeviceCommand()
      if (this.disabledMenu(72)) {
        this.$toast.error('Pastikan untuk sensor sudah aktif')
        return
      }
      this.endpoint = 'co_seco_engine'
      this.modal.cutEngine = true
      this.title = 'Cut Engine (Engine SECO) - Mesin'
      this.options = [
        { id: true, name: 'Enable' },
        { id: false, name: 'Disable' },
      ]
      this.modalMessage = 'Yakin ingin melakukan Cut Engine (Engine SECO) - Mesin'
    },

    statusCommandChange(e) {
      this.dataCommand = e
      let params = {}

      params.filters = [`vehicle_id eq ${this.vehicleId}`]
      if (this.dataCommand.start_date) {
        params.filters.push(`message_on gte '${this.dataCommand.start_date}'`)
      }
      if (this.dataCommand.end_date) {
        params.filters.push(`message_on lte '${this.dataCommand.end_date}'`)
      }
      if (this.dataCommand.filterType) {
        params.filters.push(`type eq '${this.dataCommand.filterType}'`)
      }
      if (this.dataCommand.search) {
        params.search = this.dataCommand.search
      }
      if (this.dataCommand.limit) {
        params.limit = this.dataCommand.limit
      }
      if (this.dataCommand.page) {
        params.page = this.dataCommand.page
      }

      // old
      if (this.dataCommand.limit_old) {
        params.limit = this.dataCommand.limit_old
      }
      if (this.dataCommand.page_old) {
        params.page = this.dataCommand.page_old
      }

      this.statusCommand(params)
    },

    setAlertChange(e) {
      this.dataCommand = e
      this.getRawAlert()
    },

    onFilterChange(e) {
      const self = this
      clearTimeout(self.debounceTimer)
      self.debounceTimer = setTimeout(() => {
        self.dataCommand = e
        self.getRawAlert()
      }, 500)
    },

    setEngine() {
      this.modal.cutEngine = true
      this.endpoint = 'set_engine'
      this.title = 'Set Engine'
      this.options = [
        { id: true, name: 'Enable' },
        { id: false, name: 'Disable' },
      ]
      this.modalMessage = 'Yakin ingin melakukan Pengaturan Engine'
    },

    async initStatusCommand() {
      if (!this.imei) return this.$toast.error('Pilih perangkat dulu')
      const params = {
        limit: 10,
        page: 1,
      }
      this.statusCommand(params)
    },

    async statusCommand() {
      if (!this.imei) return this.$toast.error('Pilih perangkat dulu')
      this.modal.statusCommand = true
      this.title = 'Status Online Command'
    },

    setBuzzer() {
      this.modal.cutEngine = true
      this.endpoint = 'set_buzzer'
      this.title = 'Buzzer Turn ON/OFF'
      this.options = [
        { id: true, name: 'Turn On' },
        { id: false, name: 'Turn Off' },
      ]
      this.modalMessage = 'Yakin ingin melakukan Pengaturan Buzzer'
    },

    async setHotspot() {
      if (!this.imei) return this.$toast.error('Pilih perangkat dulu')
      await this.getDeviceCommands(this.deviceCode, 'hotspot')
      this.modal.setHotspot = true
      this.endpoint = 'custom_command'
      this.options = this.deviceCommands.reverse().map((item) => {
        return { ...item, name: item.name.charAt(0).toUpperCase() + item.name.slice(1) }
      })
      this.title = this.$t('setting.list.setHotspot')
      this.modalMessage = 'Yakin ingin melakukan pengaturan hotspot?'
    },

    setVirtualSpeed() {
      this.modal.setVirtualSpeed = true
      this.endpoint = 'virtual_speed'
      this.options = [
        { id: true, name: 'Enable' },
        { id: false, name: 'Disable' },
      ]
      this.getVssDeviceCommands({ type: 'virtual_speed' })
      this.title = this.$t('setting.list.setVirtualSpeed')
      this.modalMessage = 'Yakin ingin melakukan pengaturan Virtual Speed?'
    },

    setBuzzerV2() {
      this.modal.setBuzzer = true
      this.title = 'Pengaturan Buzzer'
    },

    defaultImageCapture() {
      this.modal.defaultImageCapture = true
      this.title = 'Default Image Capture'
    },

    async setDmsDefault() {
      if (this.device.device_name?.startsWith('VSS')) {
        await this.getVssDeviceCommands()
        await this.getSensorVehicle(58, 58)
        this.modal.dmsConfiguration = true

        this.endpoint = 'dms_default'
        this.title = 'Pengaturan Bawaan DMS'
        this.options = [
          { id: true, name: 'Enable' },
          { id: false, name: 'Disable' },
        ]
        this.modalMessage = 'Yakin ingin melakukan Pengaturan Bawaan DMS'
      } else {
        const dmsSensorCode = 58
        const isEnable = this.sensors.find((sensor) => sensor?.sensor_code === dmsSensorCode)
        this.checkSensorPayload = {
          sensorCode: dmsSensorCode,
          sensorName: 'DMS',
          command: ['get_dms'],
          status: isEnable ? true : false,
        }
        this.modal.checkSensor = true
        this.endpoint = 'dms_default'
      }
    },

    setDrivingBehaviourDefault() {
      if (!this.imei) return this.$toast.error('Pilih perangkat dulu')
      this.modal.driverBehavior = true
      this.endpoint = 'driving_behaviour_default'
    },

    async submitDriverBehavior(payload) {
      await this.sendCommand(payload.endpoint, payload)
      this.getVehicleData()
      this.getSensorData()
    },

    async setADASDefault() {
      if (this.device.device_name?.startsWith('VSS')) {
        await this.getVssDeviceCommands()
        await this.getSensorVehicle(59, 59)
        this.modal.adasConfiguration = true

        this.endpoint = 'adas_default'
        this.title = 'Pengaturan ADAS'
        this.options = [
          { id: true, name: 'Enable' },
          { id: false, name: 'Disable' },
        ]
        this.modalMessage = 'Yakin ingin melakukan Pengaturan ADAS'
      } else {
        const adasSensorCode = 59
        const isEnable = this.sensors.find((sensor) => sensor?.sensor_code === adasSensorCode)
        this.checkSensorPayload = {
          sensorCode: adasSensorCode,
          sensorName: 'ADAS',
          command: ['get_adas'],
          status: isEnable ? true : false,
        }
        this.modal.checkSensor = true
        this.endpoint = 'adas_default'
      }
    },

    setDmsAlert() {
      this.modal.cutEngine = true
      this.endpoint = 'dms_alert'
      this.title = 'Pengaturan Alert DMS'
      this.options = [
        { id: true, name: 'Enable' },
        { id: false, name: 'Disable' },
      ]
      this.modalMessage = 'Yakin ingin melakukan Pengaturan Alert DMS'
    },

    setAlarmKit(endpoint) {
      this.endpoint = endpoint
      this.modal.alarmKit = true
      this.title = endpoint?.replace(/_/g, ' ')?.replace(/\b\w/g, (char) => char.toUpperCase())
      this.options = [
        { id: true, name: 'Enable' },
        { id: false, name: 'Disable' },
      ]
      this.modalMessage = 'Yakin ingin melakukan konfigurasi powermode'
    },

    sendAlarmKit() {
      this.endpoint = 'alarm_kit_cek'
      this.sendCommand(this.endpoint, { is_enable: true })
    },

    setCustomOnlineCommand() {
      if (!this.imei) return this.$toast.error('Pilih perangkat dulu')
      this.modal.customOnlineCommand = true
      this.endpoint = 'custom_command'
    },

    setCustomProfileCommand() {
      if (!this.imei) return this.$toast.error('Pilih perangkat dulu')
      this.modal.customProfileCommand = true
    },

    setCamera() {
      if (!this.imei) return this.$toast.error('Pilih perangkat dulu')
      this.modal.setCamera = true
      this.endpoint = 'device/set-camera'
    },

    setTimeInterval() {
      if (!this.imei) return this.$toast.error('Pilih perangkat dulu')
      this.modal.setTimeInterval = true
      this.endpoint = 'command'
      this.options = [
        { id: 'timer_10', name: '10 Detik' },
        { id: 'timer_30', name: '30 Detik' },
        { id: 'timer_60', name: '60 Detik' },
      ]
      this.title = this.$t('setting.list.setInterval')
      this.modalMessage = 'Yakin ingin mengatur interval?'
    },

    dmsCheck() {
      let motionStatus = ''

      switch (this.vehicleList[0].vehicle_status.motion_status) {
        case 'I':
          motionStatus = 'Diam'
          break
        case 'M':
          motionStatus = 'Bergerak'
          break
        case 'O':
          motionStatus = 'Offline'
          break
        default:
          motionStatus = 'Parkir'
          break
      }

      const device = {
        phoneNo: this.device.phone_no,
        deviceCode: this.device.device_code,
        deviceType: {
          deviceName: this.device.device_name,
        },
        deviceName: this.device.device_name,
        imei: this.device.imei,
        vehicle: {
          license_plate: this.vehicleList[0].license_plate,
          imei: this.device.imei,
          vehicle_id: this.vehicleList[0].vehicle_id,
          vehicle_status: {
            vehicle_motion_status: motionStatus,
          },
        },
      }
      localStorage.setItem('device', JSON.stringify(device))
      this.$router.push({ name: 'Track Video V2' })
    },

    setPowermode() {
      if (!this.imei) return this.$toast.error('Pilih perangkat dulu')
      this.modal.setPowermode = true
      this.endpoint = 'device/powermode-code/' + this.imei
      this.options = [
        { id: 1, name: 'Enable' },
        { id: 0, name: 'Disable' },
      ]
      this.title = this.$t('setting.list.setPowermode')
      this.modalMessage = 'Yakin ingin mengatur Powermode?'
      this.currentValue = this.devicePowermodeCode ? this.devicePowermodeCode : 0
    },

    setMode() {
      if (!this.imei) return this.$toast.error('Pilih perangkat dulu')
      this.modal.setMode = true
      this.endpoint = 'custom_command'
      this.title = this.$t('setting.list.setMode')
      this.modalMessage = 'Yakin ingin mengatur Mode?'
    },

    async setTimeZone() {
      if (!this.imei) return this.$toast.error('Pilih perangkat dulu')
      if (this.device.device_name?.startsWith('VSS')) this.getVssDeviceCommands()

      await this.getDeviceCommands(this.deviceCode, 'timezone')
      this.modal.setTimeZone = true
      this.endpoint = 'custom_command'
      this.options = this.deviceCommands
      this.title = this.$t('setting.list.setTimeZone')
      this.modalMessage = 'Yakin ingin mengatur Time Zone?'
    },

    async setTimeRecording() {
      if (!this.imei) return this.$toast.error('Pilih perangkat dulu')
      await this.getDeviceCommands(this.deviceCode, 'recording')
      this.modal.setTimeRecording = true
      this.endpoint = 'custom_command'
      this.options = this.deviceCommands
      this.title = this.$t('setting.list.setRecordingAccOff')
      this.modalMessage = 'Yakin ingin mengatur recording?'
    },

    async setTimeStandBy() {
      if (!this.imei) return this.$toast.error('Pilih perangkat dulu')
      await this.getDeviceCommands(this.deviceCode, 'standby')
      this.modal.setTimeStandBy = true
      this.endpoint = 'custom_command'
      this.options = this.deviceCommands
      this.title = this.$t('setting.list.setStandByAccOff')
      this.modalMessage = 'Yakin ingin mengatur stand by?'
    },

    async getDeviceCommands(deviceCode, command) {
      this.isLoading = true
      let params = deviceCode
        ? {
            filters: `deviceCode:eq:${deviceCode}`,
          }
        : ''
      const response = await smsAxios
        .get('/device-command', {
          params,
        })
        .catch((error) => {
          this.isLoading = false
          this.handleError(error)
        })
      if (!response.data) {
        this.isLoading = false
        return
      }
      const filteredDeviceCommand = response.data.filter((item) => item.command === command)
      this.deviceCommands = Object.entries(filteredDeviceCommand[0].data)
        .map(([name, [id]]) => ({
          id,
          name,
        }))
        .sort((a, b) => {
          const getNumber = (str) => {
            const match = str.match(/(\d+)/)
            return match ? parseInt(match[1]) : 0
          }

          const numA = getNumber(a.name)
          const numB = getNumber(b.name)

          return numA - numB
        })

      this.isLoading = false
    },

    async getVssDeviceCommands(params) {
      const response = await smsAxios
        .get(`vehicle/${this.vehicleId}/sensor`, { params })
        .catch((error) => {
          this.handleError(error)
        })
      if (!response.data) {
        return
      }

      const resultData = response.data?.data?.data
      if (!resultData) {
        return this.$toast.error('Device Offline')
      }

      this.adasInitialValue = resultData?.ADAS
      this.dmsInitialValue = resultData?.DMS
      this.vssTimezoneValue = resultData?.CLOCK
      this.virtualSpeedValue = resultData?.speed
    },

    getModes() {
      const device = Object.keys(deviceModes).find((e) => e === `device_${this.deviceCode}`)
      return { data: deviceModes[`${device}`], hasMore: false }
    },

    async setFuel() {
      this.endpoint = `masterdata/sensor/${this.vehicleId}`
      await this.getSensorData()
      await this.getVehicleData()
      this.modal.fuel = true
    },

    async setTemperature() {
      this.endpoint = `masterdata/sensor/${this.vehicleId}`
      await this.getSensorData()
      await this.getVehicleData()
      this.modal.temperature = true
    },

    async setDoor() {
      this.endpoint = `masterdata/sensor/${this.vehicleId}`
      await this.getSensorData()
      await this.getVehicleData()
      this.modal.door = true
    },

    async initSetAlertStatus() {
      if (!this.imei) return this.$toast.error('Pilih perangkat dulu')

      this.dataCommand.size = 10
      this.dataCommand.page = 1
      this.dataCommand.start_date = null
      this.dataCommand.end_date = null
      this.getRawAlert()
    },

    async getRawAlert() {
      if (!this.imei) return this.$toast.error('Pilih perangkat dulu')
      this.isStart = true
      this.modal.alertDeviceStatus = true
      this.title = 'Alert Data'

      // Parameter dasar
      const params = {
        page: this.dataCommand.page,
        limit: this.dataCommand.size, // konversi size → limit
      }

      const filters = [`vehicle_id eq ${this.vehicleId}`]

      // 1. Filter tanggal (jika ada)
      if (this.dataCommand.start_date && this.dataCommand.end_date) {
        const start = this.dataCommand.start_date
        const end = this.dataCommand.end_date
        filters.push(`created_on gte '${start}'`)
        filters.push(`created_on lte '${end}'`)
      }

      // 2. Filter is_multi_imei (ambil dari this.vehicleNew)
      //    Pastikan nilai boolean dikonversi ke string 'true'/'false' untuk OData
      filters.push(`is_multi_imei eq ${this.vehicleNew.is_multi_imei}`)

      // 3. Filter parent_vehicle_id (ambil dari this.vehicleNew)
      //    Jika null, gunakan 'null' (atau 'null' sebagai string, sesuai sintaks OData)
      filters.push(`parent_vehicle_id eq ${this.vehicleNew.parent_vehicle_id}`)

      // 4. Pencarian (search)
      if (this.dataCommand.search) {
        params.search = this.dataCommand.search
      }

      // 5. Sorting
      params.sorts = ['created_on desc']

      // Gabungkan filter
      if (filters.length) {
        params.filters = filters
      }

      // Panggil API
      const response = await rawAlertApi.get(params)
      if (response.status) {
        this.dataCommand.data = response?.data?.paginated_result
        this.dataCommand.page = response?.metadata?.page
        this.dataCommand.total_pages = response?.metadata?.total_page
        this.dataCommand.total_count = response?.metadata?.total_count
      }
      this.isStart = false
    },

    async setAlertStatus() {
      if (!this.imei) return this.$toast.error('Pilih perangkat dulu')
      this.isStart = true
      this.modal.alertDeviceStatus = true
      this.title = 'Alert Data'

      // Parameter dasar
      const params = {
        page: this.dataCommand.page,
        limit: this.dataCommand.size,
      }

      const filters = []

      // 1. Filter vehicle_id — dipakai backend untuk menentukan sensor aktif
      if (this.vehicleId) {
        filters.push(`vehicle_id eq ${this.vehicleId}`)
      }

      // 2. Filter tanggal (jika ada)
      if (this.dataCommand.start_date && this.dataCommand.end_date) {
        const start = this.dataCommand.start_date
        const end = this.dataCommand.end_date
        filters.push(`created_on gte '${start}'`)
        filters.push(`created_on lte '${end}'`)
      }

      // 3. Filter is_multi_imei (ambil dari this.vehicleNew)
      if (this.vehicleNew?.is_multi_imei !== undefined) {
        filters.push(`is_multi_imei eq ${this.vehicleNew.is_multi_imei}`)
      }

      // 4. Filter parent_vehicle_id (ambil dari this.vehicleNew)
      if (this.vehicleNew?.parent_vehicle_id !== undefined) {
        filters.push(`parent_vehicle_id eq ${this.vehicleNew.parent_vehicle_id}`)
      }

      // 5. Pencarian (search)
      if (this.dataCommand.search) {
        params.search = this.dataCommand.search
      }

      // 6. Sorting
      params.sorts = ['created_on desc']

      // Gabungkan filter
      if (filters.length) {
        params.filters = filters
      }

      // Panggil API sensor-alert (return: AlertCategoryResponse[])
      const response = await sensorAlertApi.get(params, this.region)
      if (response.status) {
        // Data sekarang berisi kategori dengan nested alert_codes
        this.dataCommand.data = response?.data?.paginated_result
        this.dataCommand.page = response?.metadata?.page
        this.dataCommand.total_pages = response?.metadata?.total_page
        this.dataCommand.total_count = response?.metadata?.total_count
      }
      this.isStart = false
    },

    async setAlertOperationalTime() {
      await this.getVehicleData()
      this.modal.alertOperationalTime = true
    },

    async getSensorData() {
      if (!this.vehicleId) return
      await toolsAxios
        .get(`/masterdata/sensor/${this.vehicleId}`, {
          headers: {
            'X-Region': this.region,
          },
        })
        .then((res) => {
          this.sensorList = res.data
          this.sensors = Array.isArray(res.data?.sensor_type) ? res.data.sensor_type : []
        })
    },

    async getSensorVehicle(sensorCode, pinCode) {
      if (!this.vehicleId) return

      let params = {
        page: 1,
        limit: 1,
        filters: [`vehicle_id eq ${this.vehicleId}`],
      }

      if (sensorCode) {
        params.filters.push(`sensor_code eq ${sensorCode}`)
      }

      if (pinCode) {
        params.filters.push(`sensor_code eq ${pinCode}`)
      }

      const res = await smsAxios.get(`/vehicle/sensor`, {
        params,
        headers: {
          'X-Region': this.region,
        },
      })

      this.vssSensorDefaultValue =
        res.data.data.paginated_result.length > 0 ? res.data.data.paginated_result[0] : null
    },

    async getVehicleData() {
      const vehicle = await toolsAxios
        .get(`/vehicle/${this.vehicleId}`, {
          headers: {
            'X-Region': this.region,
          },
        })
        .catch((error) => {
          this.handleError(error)
        })

      if (!vehicle?.data) return
      this.vehicle = vehicle.data
      this.vehicleList.shift()
      this.vehicleList.push(vehicle.data)
    },

    async getVehicleDataNew() {
      let params = {
        page: 1,
        limit: 1,
        filters: [`vehicle_id eq ${this.vehicleId}`],
      }

      const response = await vehicleApi.get(params, this.region)

      if (response.status) {
        this.vehicleNew = response.data.paginated_result?.[0]
        this.childVehicleId = response.data.paginated_result?.[0]?.child_vehicle_id

        // ★ Ambil device_code dari child vehicle bila ada
        if (this.childVehicleId) {
          await this.getChildDeviceCode()
        } else {
          this.childDeviceCode = null
        }
      }
    },

    // ★ Method baru
    async getChildDeviceCode() {
      if (!this.childVehicleId) {
        this.childDeviceCode = null
        return
      }
      try {
        const params = {
          page: 1,
          limit: 1,
          filters: [`vehicle_id eq ${this.childVehicleId}`],
        }
        const response = await deviceApi.get(params, this.region)
        this.childDeviceCode = response?.data?.paginated_result?.[0]?.device_code || null
      } catch (error) {
        this.childDeviceCode = null
        this.handleError(error)
      }
    },

    async getCamera(vehicleId) {
      const camera = await toolsAxios
        .get(`/device/get-total-camera?vehicle_id=${vehicleId}`, {
          headers: {
            'X-Region': this.region,
          },
        })
        .catch((error) => {
          if (error.response.status === 404) return
          this.handleError(error)
        })
      if (!camera?.data) return
      const cameraDataStr = camera.data.camera
      const cameraData = cameraDataStr.split(',')
      cameraData.sort()
      const cameraDataArr = []
      let j = 0
      let cameraLabel = 1
      for (let i = 0; i < this.deviceCameraMax; i++) {
        const cameraId = i + this.deviceCameraIndexStart
        let enabled = false
        if (cameraId == cameraData[j]) {
          j++
          enabled = true
        }
        cameraDataArr.push({
          camera: cameraId,
          enabled: enabled,
          cameraLabel: cameraLabel,
        })
        cameraLabel++
      }
      this.deviceCamera = cameraDataArr
    },

    async getMaxCamera(deviceCode) {
      const maxCamera = await toolsAxios
        .get(`/device/max-camera?device_code=${deviceCode}`, {
          headers: {
            'X-Region': this.region,
          },
        })
        .catch((error) => {
          if (error.response.status === 404) return
          this.handleError(error)
        })
      if (!maxCamera?.data) {
        this.deviceCamera = null
        this.deviceCameraMax = null
        return
      } else {
        this.deviceCameraMax = maxCamera.data.max
        this.deviceCameraIndexStart = maxCamera.data.index_start
        this.getCamera(this.vehicleId)
      }
    },

    handleError(error) {
      if (error.response) {
        const errorStatus = error.response.status
        const errorData = error.response.data
        if (error.response.status === 400) {
          if (error.response.data.details) {
            error.response.data.details.forEach((element) => {
              this.$toast.error(
                `${error.response.data.error} : ${element.field} ${element.message}`
              )
            })
          }
        } else if (error.response.status === 401) {
          this.$toast.error(error.response.data.error)
          localStorage.removeItem('token')
          localStorage.removeItem('tokenAccess')
          this.$router.push({ name: 'Login' })
        } else if (error.response.status === 403) {
          this.$toast.error(error.response.data.error)
        } else if (errorStatus === 409) {
          if (errorData.details) {
            errorData.details.forEach((element) => {
              this.$toast.error(`${element.message}`)
            })
          } else {
            this.$toast.error(errorData.message)
          }
        } else {
          this.$toast.error(error.response.data.error)
        }
      } else if (error.request) {
        this.$toast.error(error.response?.statusText)
      } else {
        this.$toast.error(error.message)
      }
      return
    },

    parseTemperatureString(temperatureString) {
      if (temperatureString) {
        return temperatureString
          .replace(' ', '')
          .slice(1, -1)
          .split(',')
          .map((value) => (value === 'NULL' ? '-' : value))
      }
      return ['-', '-', '-']
    },

    disabledMenu(menu) {
      const menuStr = String(menu).toLowerCase()
      const sensors = this.sensorList?.sensor_type || []
      const isChildVehicle = this.isChildVehicle()

      // ✅ KHUSUS 'get_picture': Sensor 75 HARUS aktif DAN bukan child vehicle
      if (menuStr === 'get_picture') {
        if (isChildVehicle) {
          return true
        }

        const hasImageCaptureSensor = sensors.some(
          (s) => s.sensor_code === 37 || s.sensor_code === 75 || s.sensor_code === 40
        )
        return !hasImageCaptureSensor
      }

      const inCommands = this.availableDeviceCommands.some((item) =>
        String(item.command).toLowerCase().includes(menuStr)
      )

      const inSensors = sensors.some((s) => String(s.sensor_code).includes(menuStr))

      return !(inCommands || inSensors)
    },

    async beforeSubmit(obj = null) {
      if (this.device.device_name?.startsWith('VSS')) {
        const excludedSensor = ['virtual_speed']
        switch (obj?.payload?.type) {
          case 'timezone': {
            const payload = {
              command: this.endpoint,
              sensor_code: 0,
              external_data: {
                CLOCK: {
                  timezone: this.convertTimezoneToNumber(obj?.payload?.command),
                },
              },
            }
            this.submitCommandToSms(payload)
            break
          }
          default: {
            const command = {
              command: this.endpoint,
              sensor_code: 0,
              external_data: obj,
            }
            this.submitCommandToSms(command)
            if (!excludedSensor.includes(this.endpoint)) {
              this.createUpdateVssSensor(obj)
            }
            break
          }
        }
      } else {
        this.sendCommand(this.endpoint, obj?.payload, obj?.overwrite)
      }
    },

    beforeSubmitPowermode(obj = null) {
      this.sendCommand(this.endpoint, obj?.payload, obj?.overwrite)
      this.devicePowermodeCode = obj?.payload.powermode_code
    },

    beforeSubmitMode(obj = null) {
      this.sendCommand(this.endpoint, obj?.payload, obj?.overwrite)
        .then(() => {
          this.sendCommand(
            'device/powermode-code/' + this.imei,
            {
              powermode_code: obj?.powermode,
            },
            { overwrite: obj?.overwrite }
          )
        })
        .finally(() => {
          this.getDeviceFromIMEI()
        })
    },

    beforeConfirm(endpoint, modalMessage) {
      this.endpoint = endpoint
      this.modalMessage = `Yakin ingin melakukan ${modalMessage}`
      this.modal.confirmation = true
    },

    afterConfirm() {
      this.sendCommand(this.endpoint)
    },

    async getDeviceTypes() {
      const deviceTypes = await toolsAxios.get('/qcdevice/devicetypes', {
        headers: {
          'X-Region': this.region,
        },
      })
      if (!deviceTypes?.data.length) return

      this.deviceTypes = deviceTypes.data
    },

    async getVehicles(_params) {
      let params = {
        page: 1,
        limit: this.size,
        search: this.search,
        filters: ["imei != ''", "imei != ' '", 'imei is not null'],
      }

      if (_params) {
        params.page = _params.page
        params.limit = _params.limit
        params.search = _params.search
      }
      const response = await vehicleApi.get(params, this.region)

      if (response.status) {
        this.vehicles = response?.data?.paginated_result
      }
      return response
    },

    async getVehicleLastData() {
      this.loading = true
      try {
        const response = await deviceApi.getByImei(this.imei, this.region)
        const last_vehicle = response?.data ?? {}

        this.vehicle_last_data = last_vehicle

        this.vehicle_last_data.last_packet = last_vehicle?.last_packet
        this.vehicle_last_data.last_receive = last_vehicle?.last_receive
        this.vehicle_last_data.last_position_status = last_vehicle?.last_position_status

        if (
          last_vehicle?.fuel_filtered !== null &&
          last_vehicle?.fuel_filtered !== 0 &&
          last_vehicle?.fuel_capacity !== null &&
          last_vehicle?.fuel_capacity !== 0
        ) {
          this.vehicle_last_data.fuel_filtered =
            (last_vehicle.fuel_filtered * last_vehicle.fuel_capacity) / 100
        } else {
          this.vehicle_last_data.fuel_filtered = '-'
        }

        if (last_vehicle?.obd_status) {
          this.obdData = last_vehicle.obd_status
        }
      } catch (error) {
        const errorMsg =
          error?.response?.data?.message || error.message || 'Failed to fetch vehicle data'
        console.log(errorMsg)
        this.$bvToast.toast(errorMsg, {
          title: 'Error',
          variant: 'danger',
          autoHideDelay: 5000,
        })
      } finally {
        this.loading = false
      }
    },

    async submitSetCamera(obj = null) {
      obj.payload.vehicle_id = this.vehicleId
      const options = {
        method: 'POST',
        url: '/device/set-camera',
        data: obj.payload,
        headers: {
          'X-Region': this.region,
        },
      }
      await toolsAxios(options)
        .then(() => {
          this.$toast.success('Success Send')
        })
        .catch(({ response: { data: res } }) => {
          this.$toast.error(res.error)
        })

      await this.getCamera(this.vehicleId)

      this.modal.setCamera = false
    },

    fetchOptions: debounce(function (search) {
      this.search = search
      this.getVehicles()
    }, 600),

    async onClose() {
      await this.getDeviceFromIMEI()
      await this.loadDeviceCommands()
      await this.getSensorData()
      this.observer.disconnect()
    },

    async infiniteScroll([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop
        this.size += 10
        await this.$nextTick()
        this.getVehicles()
        ul.scrollTop = scrollTop
      }
    },
    async getDeviceFromIMEI() {
      if (!this.imei) return

      let params = {
        page: 1,
        limit: 1,
        filters: [`imei eq '${typeof this.imei === 'string' ? this.imei : this.imei.imei}'`],
      }

      await deviceApi
        .get(params, this.region)
        .then(async ({ data }) => {
          this.deviceName = data.paginated_result?.[0].device_name
          this.deviceCode = data.paginated_result?.[0].device_code
          this.vehicleId = data.paginated_result?.[0].vehicle_id
          this.device = data.paginated_result?.[0]
          await this.getVehicleData()
          await this.getVehicleDataNew()
          this.devicePowermodeCode = data.paginated_result?.[0].powermode_code
          await this.getMaxCamera(data.paginated_result?.[0].device_code)
        })
        .catch(({ response: { data: res } }) => {
          console.log(res.error)
        })
    },

    async getDeviceAfterRegionChanged() {
      if (!this.imei) return
      let params = {
        page: 1,
        limit: 1,
      }

      await deviceApi
        .get(params, this.region)
        .then(async ({ data }) => {
          this.deviceName = data.paginated_result?.[0].device_name
          this.deviceCode = data.paginated_result?.[0].device_code
          this.vehicleId = data.paginated_result?.[0].vehicle_id
          this.device = data.paginated_result?.[0]
          await this.getVehicleData()
          await this.getVehicleDataNew()
          this.devicePowermodeCode = data.paginated_result?.[0].powermode_code
          await this.getMaxCamera(data.paginated_result?.[0].device_code)
        })
        .catch(({ response: { data: res } }) => {
          console.log(res.error)
        })
    },

    async reloadForm() {
      await this.getDeviceAfterRegionChanged()

      this.initialDeviceData = this.device
      this.imei = this.initialDeviceData?.imei

      await this.getDeviceFromIMEI()
      await this.getDeviceTypes()
      await this.getVehicles()
    },

    async loadDeviceCommands() {
      if (!this.deviceCode) {
        this.availableDeviceCommands = []
        return
      }

      try {
        let params = {
          filters: `deviceCode:eq:${this.deviceCode}`,
        }

        const response = await smsAxios.get('/device-command', { params })

        if (response?.data) {
          this.availableDeviceCommands = response.data
        } else {
          this.availableDeviceCommands = []
        }
      } catch (error) {
        this.availableDeviceCommands = []
        this.handleError(error)
      }
    },

    async createUpdateVssSensor(sensorData) {
      let payload = {}
      if (sensorData.type === 'ADAS') {
        payload = {
          sensor_code: 59,
          pin_code: 59,
          status_text: sensorData?.ADAS?.profile_id.toString(),
          command: 'adas_default',
        }
      } else {
        payload = {
          sensor_code: 58,
          pin_code: 58,
          status_text: sensorData?.DMS?.profile_id.toString(),
          command: 'dms_default',
        }
      }
      let options = {
        headers: {
          'X-Region': this.region,
        },
      }
      if (!this.vssSensorDefaultValue) {
        options = {
          ...options,
          method: 'POST',
          url: `vehicle/${this.vehicleId}/sensor`,
          data: { ...payload },
        }
      } else {
        options = {
          ...options,
          method: 'PATCH',
          url: `vehicle/${this.vehicleId}/sensor/${payload.sensor_code}/${payload.pin_code}`,
          data: {
            status_text: payload.status_text,
          },
        }
      }

      await smsAxios(options)
        .then(() => {
          this.$toast.success('Success Update')
        })
        .catch(() => {
          this.$toast.error('Error send command')
        })
    },

    async submitCommandToSms(payload) {
      const options = {
        method: 'POST',
        url: `/device/${this.imei}/command`,
        data: payload,
        headers: {
          'X-Region': this.region,
        },
      }

      await smsAxios(options)
        .then(() => {
          this.$toast.success('Success Send')
          this.getDeviceFromIMEI()
        })
        .catch(() => {
          this.$toast.error('Error send command')
        })

      this.isStart = false
      this.modal.cutEngine = false
      this.modal.fuel = false
      this.modal.temperature = false
      this.modal.door = false
      this.modal.customOnlineCommand = false
      this.modal.setTimeInterval = false
      this.modal.setPowermode = false
      this.modal.setMode = false
      this.modal.setTimeZone = false
      this.modal.setTimeRecording = false
      this.modal.setTimeStandBy = false
      this.modal.setHotspot = false
      this.modal.setVirtualSpeed = false
      return
    },

    convertTimezoneToNumber(tzString) {
      const parts = tzString.split(',')
      if (parts.length !== 2) {
        throw new Error('Invalid timezone string format')
      }

      const offset = parts[1]
      const hours = parseInt(offset.substring(0, 3), 10)
      const result = 120 + hours * 10
      return result
    },

    async reloadDataDeviceCommand() {
      this.initialDeviceData = JSON.parse(localStorage.getItem('device'))
      if (
        !this.initialDeviceData ||
        (this.initialDeviceData && this.device && this.initialDeviceData.imei !== this.device.imei)
      ) {
        this.initialDeviceData = this.device
      }
      this.imei = this.initialDeviceData?.imei
      await this.getDeviceFromIMEI()
      await this.loadDeviceCommands()
      await this.getSensorData()
      this.getDeviceTypes()
    },
  },

  async created() {
    this.reloadDataDeviceCommand()
  },

  async mounted() {
    this.observer = new IntersectionObserver(this.infiniteScroll)
    this.getVehicles()
    await this.getSensorData()
  },

  watch: {
    region() {
      this.reloadForm()
    },
  },
}
</script>

<template>
  <div>
    <h4 class="card-title">Pilih Perangkat</h4>
    <b-card>
      <b-row>
        <b-col md="3">
          <b-form-group id="licensePlate_plate" label-class="required">
            <FormulateInput
              type="select-resourceful"
              v-model="imei"
              placeholder="Pilih IMEI"
              :optionsGetter="getVehicles"
              :optionLabelFn="
                ({ item }) => {
                  return item.imei
                }
              "
              class="pt-0"
              trackBy="imei"
              @input="onClose"
              :allow-empty="false"
              :initialObject="initialDeviceData"
            />
          </b-form-group>
        </b-col>
        <b-col sm="12" md="3" class="pt-2">
          <b-form-group id="model_label">
            <b-form-input
              id="gpsType"
              placeholder="Tipe GPS"
              v-model="deviceName"
              disabled
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col class="pt-2">
          <div class="d-flex align-items-center">
            <b-button
              :disabled="imei == null"
              variant="primary"
              class="me-3"
              @click="lastDataModalSetting(true)"
            >
              Last Check Data
            </b-button>

            <b-button
              :disabled="imei == null"
              variant="primary"
              @click="setAlertOperationalTime(true)"
              class="d-flex align-items-center justify-content-center"
            >
              <i class="mc-fa icon-outline_clock me-2"></i> Jam Operasional
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-row class="mc-card__list">
      <h4 class="card-title">Pengaturan Device</h4>
      <b-col
        v-if="this.getAccessFunc('setDefault') || hasAccess(['sms-device-setting:read'])"
        md="6"
      >
        <b-button
          variant="outline-light"
          @click="beforeConfirm('default_setting', 'Pengaturan Awal Mobil')"
          :disabled="disabledMenu('default_setting')"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_options-2"></i>
          <div class="mc-card__list-item-content">
            <h4>{{ $t('setting.list.setDefault') }}</h4>
          </div>
        </b-button>
      </b-col>
      <b-col
        v-if="this.getAccessFunc('setDefault') || hasAccess(['sms-device-setting:read'])"
        md="6"
      >
        <b-button
          variant="outline-light"
          @click="beforeConfirm('default_setting_motor', 'Pengaturan Awal Motor')"
          :disabled="disabledMenu('default_setting_motor')"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_options-2"></i>
          <div class="mc-card__list-item-content">
            <h4>{{ $t('setting.list.setDefaultMotor') }}</h4>
          </div>
        </b-button>
      </b-col>
      <b-col md="6">
        <b-button
          variant="outline-light"
          @click="beforeConfirm('reset', 'Reset Pengaturan')"
          :disabled="disabledMenu('reset')"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_refresh"></i>
          <div class="mc-card__list-item-content">
            <h4>{{ $t('setting.list.setReset') }}</h4>
          </div>
        </b-button>
      </b-col>

      <h4 class="card-title mt-2">Pengaturan GPS & Sensor</h4>
      <b-col md="6">
        <b-button
          variant="outline-light"
          @click="engineCutIgnition"
          :disabled="disabledMenu('engine') || !disabledMenu(72) || !disabledMenu(73)"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_power"></i>

          <div class="mc-card__list-item-content">
            <h4>{{ $t('setting.list.cutEngineIgnition') }}</h4>
            <span class="text-muted" v-if="isSecoActive"
              >Gunakan seco jika pengaturan sensor Cut Off Engine (Ignition Seco) enabled</span
            >
          </div>
        </b-button>
      </b-col>
      <b-col md="6" v-if="isSecoActive">
        <b-button
          variant="outline-light"
          @click="engineCutIgnitionSeco"
          :disabled="disabledMenu(73)"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_power"></i>

          <div class="mc-card__list-item-content">
            <h4>{{ $t('setting.list.cutEngineIgnitionSeco') }}</h4>
          </div>
        </b-button>
      </b-col>
      <b-col md="6">
        <b-button
          variant="outline-light"
          @click="engineCutMachine"
          :disabled="disabledMenu('engine_2') || !disabledMenu(72) || !disabledMenu(73)"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_power"></i>

          <div class="mc-card__list-item-content">
            <h4>{{ $t('setting.list.cutEngineMachine') }}</h4>
            <span class="text-muted" v-if="isSecoActive"
              >Gunakan seco jika pengaturan sensor Cut Off Engine (Engine Seco) enabled</span
            >
          </div>
        </b-button>
      </b-col>
      <b-col md="6" v-if="isSecoActive">
        <b-button
          variant="outline-light"
          @click="engineCutMachineSeco"
          :disabled="disabledMenu(72)"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_power"></i>

          <div class="mc-card__list-item-content">
            <h4>{{ $t('setting.list.cutEngineMachineSeco') }}</h4>
          </div>
        </b-button>
      </b-col>
      <b-col md="6">
        <b-button
          variant="outline-light"
          @click="setEngine"
          :disabled="disabledMenu('engine')"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_settings"></i>
          <div class="mc-card__list-item-content">
            <h4>{{ $t('setting.list.setEngine') }}</h4>
          </div>
        </b-button>
      </b-col>
      <b-col md="6">
        <b-button
          variant="outline-light"
          @click="setTemperature"
          :disabled="disabledMenu('temp')"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_thermometer-minus"></i>
          <div class="mc-card__list-item-content">
            <h4>{{ $t('setting.list.setTemperature') }}</h4>
          </div>
        </b-button>
      </b-col>
      <b-col md="6">
        <b-button
          variant="outline-light"
          @click="setDoor"
          :disabled="disabledMenu('door')"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_door-open"></i>
          <div class="mc-card__list-item-content">
            <h4>{{ $t('setting.list.setDoor') }}</h4>
          </div>
        </b-button>
      </b-col>
      <b-col md="6">
        <b-button
          variant="outline-light"
          @click="setBuzzer"
          :disabled="disabledMenu('set_buzzer')"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_bell"></i>
          <div class="mc-card__list-item-content">
            <h4>{{ $t('setting.list.setBuzzer') }}</h4>
          </div>
        </b-button>
      </b-col>
      <b-col md="6">
        <b-button
          variant="outline-light"
          @click="setBuzzerV2"
          :disabled="disabledMenu('buzzer')"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_bell"></i>
          <div class="mc-card__list-item-content">
            <h4>{{ $t('setting.list.setBuzzer2') }}</h4>
          </div>
        </b-button>
      </b-col>
      <b-col md="6">
        <b-button
          variant="outline-light"
          @click="setFuel"
          :disabled="disabledMenu('fuel')"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_fuel"></i>
          <div class="mc-card__list-item-content">
            <h4>{{ $t('setting.list.setFuel') }}</h4>
          </div>
        </b-button>
      </b-col>
      <b-col md="6">
        <b-button
          variant="outline-light"
          @click="setDrivingBehaviourDefault"
          :disabled="disabledMenu('driving_behavior_')"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_steering-wheel"></i>
          <div class="mc-card__list-item-content">
            <h4>Pengaturan Perilaku Pengemudi</h4>
          </div>
        </b-button>
      </b-col>
      <b-col md="6">
        <b-button
          variant="outline-light"
          @click="setPowermode"
          class="d-block w-100 mc-card__list-item clearfix"
          :disabled="disabledMenu('powermode')"
        >
          <i class="mc-fa icon-fill_power"></i>
          <div class="mc-card__list-item-content">
            <h4>{{ $t('setting.list.setPowermode') }}</h4>
          </div>
        </b-button>
      </b-col>
      <b-col md="6">
        <b-button
          variant="outline-light"
          @click="setMode"
          class="d-block w-100 mc-card__list-item clearfix"
          :disabled="disabledMenu('setMode')"
        >
          <i class="mc-fa icon-outline_keypad"></i>
          <div class="mc-card__list-item-content">
            <h4>{{ $t('setting.list.setMode') }}</h4>
          </div>
        </b-button>
      </b-col>

      <h4 class="card-title mt-2">Pengaturan Trackvision</h4>
      <b-col md="6">
        <b-button
          variant="outline-light"
          @click="setDmsDefault"
          :disabled="disabledMenu('dms_default')"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_video"></i>
          <div class="mc-card__list-item-content">
            <h4>{{ $t('setting.list.setDmsDefault') }}</h4>
          </div>
        </b-button>
      </b-col>
      <b-col md="6" class="d-none">
        <b-button
          variant="outline-light"
          @click="setDmsAlert"
          :disabled="disabledMenu('dms_alert')"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_alert-triangle"></i>
          <div class="mc-card__list-item-content">
            <h4>{{ $t('setting.list.setDmsAlert') }}</h4>
          </div>
        </b-button>
      </b-col>
      <b-col md="6">
        <b-button
          variant="outline-light"
          @click="setDrivingBehaviourDefault"
          :disabled="disabledMenu('driving_behaviour_default')"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_steering-wheel"></i>
          <div class="mc-card__list-item-content">
            <h4>{{ $t('setting.list.setDrivingBehaviourDefault') }}</h4>
          </div>
        </b-button>
      </b-col>
      <b-col md="6">
        <b-button
          variant="outline-light"
          @click="setADASDefault"
          :disabled="disabledMenu('adas_default')"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_person"></i>
          <div class="mc-card__list-item-content">
            <h4>{{ $t('setting.list.setADASDefault') }}</h4>
          </div>
        </b-button>
      </b-col>
      <b-col md="6">
        <b-button
          variant="outline-light"
          @click="dmsCheck"
          :disabled="disabledMenu(35) && $store.state.config.dmsCheck"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_play-circle"></i>
          <div class="mc-card__list-item-content">
            <h4>{{ $t('setting.list.streamingVideos') }}</h4>
          </div>
        </b-button>
      </b-col>
      <b-col md="6">
        <b-button
          variant="outline-light"
          :disabled="deviceCameraMax == null"
          @click="setCamera"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_camera"></i>
          <div class="mc-card__list-item-content">
            <h4>{{ $t('setting.list.setCamera') }}</h4>
          </div>
        </b-button>
      </b-col>
      <b-col md="6">
        <b-button
          variant="outline-light"
          :disabled="disabledMenu('interval')"
          @click="setTimeInterval"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_timer"></i>
          <div class="mc-card__list-item-content">
            <h4>{{ $t('setting.list.setInterval') }}</h4>
          </div>
        </b-button>
      </b-col>
      <b-col md="6">
        <b-button
          variant="outline-light"
          :disabled="disabledMenu('standby')"
          @click="setTimeStandBy"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_timer"></i>
          <div class="mc-card__list-item-content">
            <h4>{{ $t('setting.list.setStandByAccOff') }}</h4>
          </div>
        </b-button>
      </b-col>
      <b-col md="6">
        <b-button
          variant="outline-light"
          :disabled="disabledMenu('recording')"
          @click="setTimeRecording"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_timer"></i>
          <div class="mc-card__list-item-content">
            <h4>{{ $t('setting.list.setRecordingAccOff') }}</h4>
          </div>
        </b-button>
      </b-col>
      <b-col md="6">
        <b-button
          variant="outline-light"
          @click="setTimeZone"
          class="d-block w-100 mc-card__list-item clearfix"
          :disabled="disabledMenu('timezone')"
        >
          <i class="mc-fa icon-outline_globe"></i>
          <div class="mc-card__list-item-content">
            <h4>{{ $t('setting.list.setTimeZone') }}</h4>
          </div>
        </b-button>
      </b-col>
      <b-col md="6">
        <b-button
          variant="outline-light"
          @click="defaultImageCapture"
          class="d-block w-100 mc-card__list-item clearfix"
          :disabled="disabledMenu('get_picture')"
        >
          <i class="mc-fa icon-outline_camera"></i>
          <div class="mc-card__list-item-content">
            <!-- Judul Utama -->
            <h4>Konfigurasi Media Evidence</h4>
          </div>
        </b-button>
      </b-col>
      <b-col md="6">
        <b-button
          variant="outline-light"
          @click="setHotspot"
          :disabled="disabledMenu('hotspot')"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_wifi"></i>
          <div class="mc-card__list-item-content">
            <h4>{{ $t('setting.list.setHotspot') }}</h4>
          </div>
        </b-button>
      </b-col>
      <b-col md="6">
        <b-button
          variant="outline-light"
          @click="setVirtualSpeed"
          :disabled="disabledMenu('virtual_speed')"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_wifi"></i>
          <div class="mc-card__list-item-content">
            <h4>{{ $t('setting.list.setVirtualSpeed') }}</h4>
          </div>
        </b-button>
      </b-col>
      <h4 class="card-title mt-2">Custom Parameter</h4>
      <b-col md="6">
        <b-button
          variant="outline-light"
          @click="setCustomProfileCommand"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_options-2"></i>
          <div class="mc-card__list-item-content">
            <h4>Custom Profile</h4>
            <span class="text-muted">
              Enable / disable profile dan pilih profile yang dipakai di perangkat
            </span>
          </div>
        </b-button>
      </b-col>
      <h4 class="card-title mt-2">Alarm Kit</h4>
      <b-col md="6">
        <b-button
          variant="outline-light"
          @click="() => setAlarmKit('alarm_kit_buzzer')"
          :disabled="disabledMenu(74)"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_bell"></i>
          <div class="mc-card__list-item-content">
            <h4>Alarm Kit - Buzzer</h4>
            <span class="text-muted" v-if="isSecoActive">
              Aktifkan buzzer pada Custom Scenario.
            </span>
          </div>
        </b-button>
      </b-col>
      <b-col md="6">
        <b-button
          variant="outline-light"
          @click="() => setAlarmKit('alarm_kit_door')"
          :disabled="disabledMenu(74)"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_door-open"></i>
          <div class="mc-card__list-item-content">
            <h4>Alarm Kit - Door</h4>
            <span class="text-muted" v-if="isSecoActive">
              Aktifkan sensor pintu pada Custom Scenario.
            </span>
          </div>
        </b-button>
      </b-col>
      <b-col md="6">
        <b-button
          variant="outline-light"
          @click="() => setAlarmKit('alarm_kit_pir')"
          :disabled="disabledMenu(74)"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_radio"></i>
          <div class="mc-card__list-item-content">
            <h4>Alarm Kit - PIR</h4>
            <span class="text-muted" v-if="isSecoActive">
              Aktifkan sensor gerakan PIR pada Custom Scenario.
            </span>
          </div>
        </b-button>
      </b-col>
      <b-col md="6">
        <b-button
          variant="outline-light"
          @click="() => setAlarmKit('alarm_kit_disarm')"
          :disabled="disabledMenu(74)"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_info"></i>
          <div class="mc-card__list-item-content">
            <h4>Alarm Kit - Disarm</h4>
            <span class="text-muted" v-if="isSecoActive">
              Aktifkan sensor disarm pada Custom Scenario.
            </span>
          </div>
        </b-button>
      </b-col>
      <b-col md="6">
        <b-button
          variant="outline-light"
          @click="() => setAlarmKit('alarm_kit_vibration')"
          :disabled="disabledMenu(74)"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_alert-triangle"></i>
          <div class="mc-card__list-item-content">
            <h4>Alarm Kit - Vibration</h4>
            <span class="text-muted" v-if="isSecoActive">
              Aktifkan sensor getaran pada Custom Scenario.
            </span>
          </div>
        </b-button>
      </b-col>
      <b-col md="6">
        <b-button
          variant="outline-light"
          @click="() => setAlarmKit('alarm_kit_temperature')"
          :disabled="disabledMenu(74)"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_thermometer-minus"></i>
          <div class="mc-card__list-item-content">
            <h4>Alarm Kit - Temperature</h4>
            <span class="text-muted" v-if="isSecoActive">
              Aktifkan sensor suhu pada Custom Scenario.
            </span>
          </div>
        </b-button>
      </b-col>
      <b-col md="6">
        <b-button
          variant="outline-light"
          @click="sendAlarmKit"
          :disabled="disabledMenu(74)"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_info"></i>
          <div class="mc-card__list-item-content">
            <h4>Alarm Kit - Cek</h4>
            <span class="text-muted" v-if="isSecoActive">
              Tampilkan konfigurasi Custom Scenario saat ini.
            </span>
          </div>
        </b-button>
      </b-col>
    </b-row>

    <b-row class="mc-card__list">
      <h4 class="card-title mt-2">Pengecekan Status Device</h4>
      <b-col md="6">
        <b-button
          variant="outline-light"
          @click="setCustomOnlineCommand"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_cloud-upload"></i>
          <div class="mc-card__list-item-content">
            <h4>{{ $t('setting.list.setCustomOnlineCommand') }}</h4>
          </div>
        </b-button>
      </b-col>
      <b-col md="6">
        <b-button
          variant="outline-light"
          @click="beforeConfirm('version', 'Check Version Perangkat')"
          :disabled="disabledMenu('version')"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_question-mark-circle"></i>
          <div class="mc-card__list-item-content">
            <h4>{{ $t('setting.list.checkVersion') }}</h4>
          </div>
        </b-button>
      </b-col>
      <b-col md="6">
        <b-button
          variant="outline-light"
          @click="beforeConfirm('status', 'Check Status Perangkat')"
          :disabled="disabledMenu('status')"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_info"></i>
          <div class="mc-card__list-item-content">
            <h4>{{ $t('setting.list.checkStatus') }}</h4>
          </div>
        </b-button>
      </b-col>
      <b-col md="6">
        <b-button
          variant="outline-light"
          @click="beforeConfirm('param', 'Pengaturan Parameter')"
          :disabled="disabledMenu('param')"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_radio"></i>
          <div class="mc-card__list-item-content">
            <h4>{{ $t('setting.list.setParam') }}</h4>
          </div>
        </b-button>
      </b-col>
      <b-col md="6">
        <b-button
          variant="outline-light"
          @click="initStatusCommand"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_info"></i>
          <div class="mc-card__list-item-content">
            <h4>{{ $t('setting.list.checkCommand') }}</h4>
          </div>
        </b-button>
      </b-col>
      <b-col md="6">
        <b-button
          variant="outline-light"
          @click="initSetAlertStatus"
          class="d-block w-100 mc-card__list-item clearfix"
        >
          <i class="mc-fa icon-outline_alert-triangle"></i>
          <div class="mc-card__list-item-content">
            <h4>{{ $t('setting.list.setAlertStatus') }}</h4>
          </div>
        </b-button>
      </b-col>
    </b-row>
    <form-fuel
      v-if="modal.fuel"
      :modal.sync="modal.fuel"
      :sensor="sensorList"
      :vehicles="vehicleList"
      :deviceCode="deviceCode"
      :is-loading.sync="isStart"
      :region="region"
      @beforeSubmit="beforeSubmit"
    />
    <form-temperature
      v-if="modal.temperature"
      :modal.sync="modal.temperature"
      :sensor="sensorList"
      :vehicles="vehicleList"
      :is-loading.sync="isStart"
      @beforeSubmit="beforeSubmit"
      :region="region"
    />
    <FormDoor
      v-if="modal.door"
      :modal.sync="modal.door"
      :sensor="sensorList"
      :vehicles="vehicleList"
      :is-loading.sync="isStart"
      @beforeSubmit="beforeSubmit"
      :region="region"
    />
    <form-cut-engine
      v-if="
        modal.cutEngine &&
        (this.getAccessRight('qcDevice') ||
          hasAccess(['sms-device-setting:create', 'sms-device-setting:update']))
      "
      :title="title"
      :modal.sync="modal.cutEngine"
      :options="options"
      :message="modalMessage"
      :is-loading.sync="isStart"
      @beforeSubmit="beforeSubmit"
      :region="region"
    />
    <form-alarm-kit
      v-if="
        modal.alarmKit &&
        (this.getAccessRight('qcDevice') ||
          hasAccess(['sms-device-setting:create', 'sms-device-setting:update']))
      "
      :title="title"
      :modal.sync="modal.alarmKit"
      :options="options"
      :message="modalMessage"
      :is-loading.sync="isStart"
      @beforeSubmit="beforeSubmit"
      :region="region"
    />
    <form-set-buzzer
      v-if="
        modal.setBuzzer &&
        (this.getAccessRight('qcDevice') ||
          hasAccess(['sms-device-setting:create', 'sms-device-setting:update']))
      "
      :title="title"
      :modal.sync="modal.setBuzzer"
      :options="options"
      :vehicleId="vehicleId"
      :deviceCode="deviceCode"
      :message="modalMessage"
      :is-loading.sync="isStart"
      @beforeSubmit="beforeSubmit"
      :region="region"
    />
    <form-set-hotspot
      v-if="modal.setHotspot"
      :title="title"
      :modal.sync="modal.setHotspot"
      :options="options"
      :message="modalMessage"
      :is-loading.sync="isStart"
      @beforeSubmit="beforeSubmit"
      :region="region"
    />
    <form-set-virtual-speed
      v-if="modal.setVirtualSpeed"
      :title="title"
      :modal.sync="modal.setVirtualSpeed"
      :options="options"
      :message="modalMessage"
      :is-loading.sync="isStart"
      @beforeSubmit="beforeSubmit"
      :region="region"
      :data="virtualSpeedValue"
    />
    <FormDefaultImageCapture
      v-if="
        modal.defaultImageCapture &&
        (this.getAccessRight('qcDevice') ||
          hasAccess(['sms-device-setting:create', 'sms-device-setting:update']))
      "
      :title="title"
      :modal.sync="modal.defaultImageCapture"
      :options="options"
      :vehicleId="vehicleId"
      :deviceCode="defaultImageCaptureDeviceCode"
      :message="modalMessage"
      :is-loading.sync="isStart"
      @beforeSubmit="beforeSubmit"
      :region="region"
      :childVehicleId="childVehicleId"
    />
    <form-custom-online-command
      v-if="
        modal.customOnlineCommand &&
        (this.getAccessRight('qcDevice') ||
          hasAccess(['sms-device-setting:create', 'sms-device-setting:update']))
      "
      :modal.sync="modal.customOnlineCommand"
      :is-loading.sync="isStart"
      @beforeSubmit="beforeSubmit"
      :region="region"
    />
    <form-custom-profile-command
      v-if="
        modal.customProfileCommand &&
        (this.getAccessRight('qcDevice') ||
          hasAccess(['sms-device-setting:create', 'sms-device-setting:update']))
      "
      :modal.sync="modal.customProfileCommand"
      :vehicle="vehicleList[0]"
      :device="device"
      :device-code="deviceCode"
      :imei="typeof imei === 'string' ? imei : imei?.imei"
      :region="region"
      :deviceTypes="deviceTypes"
      @beforeSubmit="getDeviceFromIMEI"
    />
    <form-status-command
      v-if="
        modal.statusCommand &&
        (this.getAccessRight('qcDevice') ||
          hasAccess(['sms-device-setting:create', 'sms-device-setting:update']))
      "
      :title="title"
      :modal.sync="modal.statusCommand"
      :vehicleId="vehicleId"
      :region="region"
    />
    <form-alert-device-status
      v-if="modal.alertDeviceStatus"
      :title="title"
      :modal.sync="modal.alertDeviceStatus"
      :dataCommand="dataCommand"
      :is-loading.sync="isStart"
      @beforeSubmit="beforeSubmit"
      @set-alert-change="setAlertChange"
      @filter-change="onFilterChange"
      :region="region"
    />
    <FormSetInterval
      v-if="modal.setTimeInterval"
      :title="title"
      :modal.sync="modal.setTimeInterval"
      :options="options"
      :message="modalMessage"
      :is-loading.sync="isStart"
      @beforeSubmit="beforeSubmit"
      :region="region"
    />
    <FormSetRecording
      v-if="modal.setTimeRecording"
      :title="title"
      :modal.sync="modal.setTimeRecording"
      :options="options"
      :message="modalMessage"
      :is-loading.sync="isStart"
      @beforeSubmit="beforeSubmit"
      :region="region"
    />
    <FormSetStandBy
      v-if="modal.setTimeStandBy"
      :title="title"
      :modal.sync="modal.setTimeStandBy"
      :options="options"
      :message="modalMessage"
      :is-loading.sync="isStart"
      @beforeSubmit="beforeSubmit"
      :region="region"
    />
    <form-set-powermode
      v-if="modal.setPowermode"
      :title="title"
      :modal.sync="modal.setPowermode"
      :options="options"
      :message="modalMessage"
      :is-loading.sync="isStart"
      :currentValue="currentValue"
      @beforeSubmit="beforeSubmitPowermode"
      :region="region"
    />
    <form-set-mode
      v-if="modal.setMode"
      :title="title"
      :modal.sync="modal.setMode"
      :message="modalMessage"
      :is-loading.sync="isStart"
      :modes="getModes"
      @beforeSubmit="beforeSubmitMode"
      :region="region"
    />
    <FormSetCamera
      v-if="
        modal.setCamera &&
        (this.getAccessRight('qcDevice') ||
          hasAccess(['sms-device-setting:create', 'sms-device-setting:update']))
      "
      :title="title"
      :modal.sync="modal.setCamera"
      :is-loading.sync="isStart"
      :max-camera="deviceCameraMax"
      :index-start="deviceCameraIndexStart"
      :camera="deviceCamera"
      @submit="submitSetCamera"
      :region="region"
    />
    <FormSetTimeZone
      v-if="modal.setTimeZone"
      :title="title"
      :modal.sync="modal.setTimeZone"
      :options="options"
      :message="modalMessage"
      :is-loading.sync="isStart"
      @beforeSubmit="beforeSubmit"
      :region="region"
      :device="device"
      :vssTimezoneValue="vssTimezoneValue"
    />
    <FormAlertOperationalTime
      v-if="modal.alertOperationalTime"
      :isOpen="modal.alertOperationalTime"
      :title="title"
      :modal.sync="modal.alertOperationalTime"
      :options="options"
      :vehicleId="vehicleId"
      :vehicle="vehicleList[0]"
      :message="modalMessage"
      :is-loading.sync="isStart"
      @beforeSubmit="beforeSubmit"
      :region="region"
    />
    <FormSetDmsVss
      :modal.sync="modal.dmsConfiguration"
      :is-loading.sync="isStart"
      :deviceType="deviceCode.toString()"
      :dms-initial-value="dmsInitialValue"
      @beforeSubmit="beforeSubmit"
      :initialProfile="vssSensorDefaultValue"
    />
    <FormSetAdasVss
      :modal.sync="modal.adasConfiguration"
      :is-loading.sync="isStart"
      :deviceType="deviceCode.toString()"
      :adas-initial-value="adasInitialValue"
      @beforeSubmit="beforeSubmit"
      :initialProfile="vssSensorDefaultValue"
    />
    <FormCheckSensor
      :modal.sync="modal.checkSensor"
      :sensorCode="checkSensorPayload.sensorCode"
      :sensorName="checkSensorPayload.sensorName"
      :device="device"
      :command="checkSensorPayload.command"
      :status="checkSensorPayload.status"
      :region="region"
    />
    <FormDriverBehavior
      v-if="modal.driverBehavior"
      :sensor="sensorList?.sensor_type || []"
      :vehicle="vehicleList[0]"
      :modal.sync="modal.driverBehavior"
      :is-loading.sync="isStart"
      :region="region"
      @submit="submitDriverBehavior"
    />
    <confirmation
      v-if="modal.confirmation"
      :modal.sync="modal.confirmation"
      :message="modalMessage"
      @confirmed="afterConfirm"
    />
    <VideoList />
    <ModalLastCheckData
      :vehicle_last_data="vehicle_last_data"
      :device_code="deviceCode || 0"
      :region="this.region"
      @close="lastDataModalSetting(false)"
    />
  </div>
</template>
